import React, { useState, useEffect } from 'react';
import ApiService from '../../services/apiService';

const ItemGridPurchaseReturnView = ({ GrnItemData, currencyPrecision }) => {
    const apiService = new ApiService();
    const [rows, setRows] = useState([{
        requisitionNo: '',
        srno: '',
        recordId: '',
        ItemNo: '',
        itemDescription: '',
        specification: '',
        balqty: '',
        uom: '',
        baseQty: '',
        baseAmount: '',
        amount: '',
        discount: '',
        vat: '',
        vatAmount: '',
        vatDec: '',
        conValue: '',
        expDate: '',
    }]);
    useEffect(() => {
        getItems();
    }, [GrnItemData]);

    const getItems = async () => {
        try {
            let param = `?GRNNo=${GrnItemData?.grnNo}`
            const PO = await apiService.getApiParamater("GET_GRN_P_RETURN", param);
             
            const formattedRowsitm = GrnItemData?.purchaseReturnDetails?.map(async (detail, index) => {
                const selectedGrnItem = PO?.data?.result?.find(rec => rec.itemDescription === detail.itemDescription)
                const selecteditmstock = await apiService.getApiParamater('GET_ITEM', `?Warehouse=${GrnItemData?.warehouse}&ItemNo=${detail?.itemCode}`);
                let item = selecteditmstock?.data?.result?.[0]
                return {
                    srno: detail?.srno,
                    itemCode: detail.itemCode,
                    itemDescription: detail.itemDescription,
                    balqty: selectedGrnItem?.balQty || 0,
                    qty: detail?.qty,
                    stockloc: (item?.stock / detail.convToInvUOM)?.toFixed(2),
                    convToInvUOM: detail.convToInvUOM,
                    uom: detail.uom,
                    baseAmount: detail.amount,
                    specification: detail.specification,
                    unitPrice: detail.unitPrice,
                    amount: detail?.amount,
                    vatPerc: detail.vatPerc || 0,
                    vatAmount: detail.vatAmount,
                    vatDec: detail?.vatDesc,
                };
            }).filter(row => row !== null);
            const formattedRows = await Promise.all(formattedRowsitm);
            if (formattedRows.length > 0) {
                setRows(formattedRows);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
            setRows([{
                requisitionNo: '',
                srno: '',
                recordId: '',
                ItemNo: '',
                itemDescription: '',
                specification: '',
                balqty: '',
                uom: '',
                baseQty: '',
                baseAmount: '',
                amount: '',
                discount: '',
                vat: '',
                vatAmount: '',
                vatDec: '',
                conValue: '',
                expDate: '',
            }]);
        }
    };

    return (
        <div>
            <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
                <table>
                    <thead className='dynoTable' >
                        <tr>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Packing UOM</th>
                            <th>Inventory Qty</th>
                            <th>Bal Qty</th>
                            <th>Loc Stock</th>
                            <th>Unit Price</th>
                            <th>VAT</th>
                            <th>VAT %</th>
                            <th>VAT Amount</th>
                            <th>Amount</th>
                            <th>Exp Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row, index) => (
                            <tr key={index}>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={index + 1} disabled style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemCode} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemDescription} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled style={{ width: "100px" }} value={row.qty} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.uom} style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={(row.qty * row.convToInvUOM) || 0} style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.balqty || 0} style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.stockloc || 0} style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={Number(row?.unitPrice || 0).toFixed(currencyPrecision || 0)} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.vatDec} disabled style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.vatPerc} disabled style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={Number(row?.vatAmount || 0).toFixed(currencyPrecision || 0)} disabled style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={Number(row?.amount || 0).toFixed(currencyPrecision || 0)} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type='date' value={row?.expDate?.split('T')[0]} disabled style={{ width: "130px" }} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ItemGridPurchaseReturnView;